// auto-generated - do not edit

export const MINIMUM_BROWSER_VERSIONS = {
  "chrome": 138,
  "edge": 138,
  "firefox": 140,
  "safari": 26
};
